export function getPlaceholder(showPaginator: boolean, showRowPerPage: number) {
  return showPaginator
    ? Array.from({ length: showRowPerPage || 5 }, (_, i) => i)
    : Array.from({ length: 100 }, (_, i) => i);
}

export function getNumberOfPages(
  loading: boolean,
  showRowPerPage: number,
  totalCount: number
) {
  return loading ? showRowPerPage || 5 : totalCount;
}

export function getWidth(width?: number) {
  if (!width) {
    return { minWidth: 200, width: 200 };
  }
  if (width < 100) {
    return { minWidth: 100, width: 100 };
  }
  return width ? { minWidth: width, width: width } : {};
}
